import { Accordion } from 'components/Accordion';
import { useState } from 'react';
import type { IGetSeoContentData } from './helpers';
import { ScFaqSection, ScFaqSectionTitle } from './styled';

type FaqSectionProps = Pick<IGetSeoContentData, 'faqItems' | 'faqTitle'>;

export const FaqSection = ({ faqItems, faqTitle }: FaqSectionProps) => {
  const [active, setActive] = useState<number | false>(false);

  return (
    <ScFaqSection>
      {faqTitle && <ScFaqSectionTitle>{faqTitle}</ScFaqSectionTitle>}
      <Accordion
        isTransparent
        items={faqItems.map((item, index) => ({
          title: item.question,
          body: item.answer,
          isOpen: active === index,
          handleOpen: () => setActive(active === index ? false : index),
        }))}
      />
    </ScFaqSection>
  );
};
